import { Injectable } from '@nestjs/common';
import { Address } from '../address.entity';
import { Customers } from '../customers.entity';
import { CustomersDTO } from './customers.dto';


@Injectable()
export class CustomersAdapter {
  /**
   *
   * @param CustomersDto
   * @returns Customers entity
   */
  public convertDtoToEntity(  customersDTO: CustomersDTO,  isUpdate: boolean = false ): Customers {
    const customer = new Customers();
    console.log(customersDTO);
    customer.custId=customersDTO.custId;
    customer.clientCode=customersDTO.clientCode;
    customer.clientName=customersDTO.clientName;
    customer.accountType=customersDTO.accountType;
    customer.gstNumber=customersDTO.gstNumber;
    customer.website=customersDTO.website;
    customer.phoneNo=customersDTO.phoneNo;
    // customer.appartment=customersDTO.appartment;
    // customer.street=customersDTO.street;
    // customer.state=customersDTO.state;
    // customer.city=customersDTO.city;
    customer.contactPerson=customersDTO.contactPerson;
    customer.countryId=customersDTO.countryId;
    customer.email=customersDTO.email;
    // customer.postalCode=customersDTO.postalCode;
    customer.publicNote=customersDTO.publicNote;
    customer.privateNote=customersDTO.privateNote;
    customer.ratePerHour=customersDTO.ratePerHour;
    customer.currency=customersDTO.currency;
    customer.paymentTerms=customersDTO.paymentTerms;
    customer.shipmentTerms=customersDTO.shipmentTerms;
    customer.paymentModeId=customersDTO.paymentModeId;
    // customer.customerAccountType=customersDTO.customerAccountType;
    customer.isActive=customersDTO.isActive==undefined?true:customersDTO.isActive;

    const addressItems: Address[] = [];
    for (const soItem of customersDTO.cusAddressInfo) {
        const addressObj: Address = new Address();
        // addressObj.saleOrderId = entityObj.saleOrderId;
        addressObj.addLineOne = soItem.addLineOne;
        addressObj.addLineTwo = soItem.addLineTwo;
        addressObj.addLineThree = soItem.addLineThree;
        addressObj.addressType = 'Customer';
        addressObj.addLineFour = soItem.addLineFour;
        
        addressObj.createdUser = soItem.createdUser;
        
        addressItems.push(addressObj);
    }

    if (isUpdate) {
      customer.updatedUser = customersDTO.updatedUser;
    } else {
      customer.isActive = true;
      customer.createdUser = customersDTO.createdUser;
    }

    customer.cusAddressInfo = addressItems;
    console.log(customersDTO);

   return customer;
  }
  public convertEntityToDto(customersObject: Customers): CustomersDTO {
    const customersDTO= new CustomersDTO;
    customersDTO.custId=customersObject.custId;
    customersDTO.clientCode=customersObject.clientCode;
    customersDTO.clientName=customersObject.clientName;
    customersDTO.accountType=customersObject.accountType;
    customersDTO.gstNumber=customersObject.gstNumber;
    customersDTO.website=customersObject.website;
    customersDTO.phoneNo=customersObject.phoneNo;
    // customersDTO.appartment=customersObject.appartment;
    // customersDTO.street=customersObject.street;
    // customersDTO.state=customersObject.state;
    // customersDTO.city=customersObject.city;
    customersDTO.contactPerson=customersObject.contactPerson;
    customersDTO.countryId=customersObject.countryId;
    customersDTO.email=customersObject.email;
    // customersDTO.postalCode=customersObject.postalCode;
    customersDTO.publicNote=customersObject.publicNote;
    customersDTO.privateNote=customersObject.privateNote;
    customersDTO.ratePerHour=customersObject.ratePerHour;
    customersDTO.currency=customersObject.currency;
    customersDTO.paymentTerms=customersObject.paymentTerms;
    customersDTO.shipmentTerms=customersObject.shipmentTerms;
    customersDTO.paymentModeId=customersObject.paymentModeId;
    // customersDTO.customerAccountType=customersObject.customerAccountType;
    customersDTO.isActive = customersObject.isActive;
    customersDTO.createdAt = customersObject.createdAt;
    customersDTO.updatedAt = customersObject.updatedAt;
    customersDTO.createdUser = customersObject.createdUser;
    customersDTO.updatedUser = customersObject.updatedUser;
    customersDTO.versionFlag = customersObject.versionFlag;
    customersDTO.cusAddressInfo = customersObject.cusAddressInfo;
    return customersDTO;
  }
}
